// Base URL for all endpoints post login (business endpoints)
export const BUSINESS_BASE_URL = "https://sudburry-java-service.onrender.com";

// Base URL for login/register/signup/logout (API Gateway)
const BASE_URL = "https://sudbury-auth-service.onrender.com";

// Auth service URL (same as BASE_URL for login/signup/logout)
export const AUTH_BASE_URL = "https://sudbury-auth-service.onrender.com";

export default BASE_URL;
